export class LanguageTranslationCommandModel {
    public languageTranslationId: string
    public entityName: string;
    public entityPrimaryKey: string;
    public languageCode: string;
    public languageName: string;
    public translation: string;
} 